<template>
  <div style="display: inline;">
    <el-button icon="el-icon-s-claim" type="primary" @click="handleShow" size="mini" style="background: #e03f3d">
      是我的
    </el-button>
    <el-drawer :title="`认领${artist_name}的直播佣金数据`" :visible.sync="show" :close-on-press-escape='false'
               :wrapper-closable='false'
               custom-class="live-guarantee-store-claim-drawer default-table">
      <el-form :model="form" :rules="rules" ref="form">
        <!--        <div v-loading="load" class="module module-order">-->
        <!--          <p class="module__title">-->
        <!--            归属全案营销订单-->
        <!--            <el-button v-if="order&&order.customer_name" size="mini" style="margin-left: 20px;"-->
        <!--                       @click="()=>{order={};form.order_no=null;}">-->
        <!--              修改订单-->
        <!--            </el-button>-->
        <!--          </p>-->
        <!--          <div class="module__content" style="display: flex;align-items: center;justify-content: center;">-->
        <!--            <el-descriptions v-if="order&&order.customer_name" :column="3">-->
        <!--              <el-descriptions-item label="全案订单编号">{{ order.order_no || '' }}</el-descriptions-item>-->
        <!--              <el-descriptions-item label="总含税收入">{{ order.payment_account |numberFormat(2) }}-->
        <!--              </el-descriptions-item>-->
        <!--              <el-descriptions-item label="品牌">{{ order.brand || '' }}</el-descriptions-item>-->
        <!--              <el-descriptions-item label="客户">{{ order.customer_name || '' }}</el-descriptions-item>-->
        <!--              <el-descriptions-item label="产品/内容">{{ order.product || '' }}</el-descriptions-item>-->
        <!--            </el-descriptions>-->
        <!--            <el-form-item v-else prop="order_no">-->
        <!--              <el-input placeholder="请输入归属的全案营销订单编号" v-model="form.order_no" class="input-with-select"-->
        <!--                        style="width: 500px;"/>-->
        <!--            </el-form-item>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="module module-live">
          <p class="module__title">完善佣金数据</p>
          <div class="module__content" style="height: calc(100% - 10px);">
            <el-table :data="table" show-summary height="100%">
              <el-table-column type="index" width="50"/>
              <el-table-column label="月份">
                <template v-slot="{row:{date_live,shop_name}}">
                  <div>{{ date_live|parseTime('{y}年{m}月') }}</div>
                  <div>{{ shop_name }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="artist_name" label="达人昵称" show-overflow-tooltip/>
              <el-table-column prop="shop_name" label="店铺名称" show-overflow-tooltip/>
              <el-table-column prop="sales_volume" label="订单数" :render-header="renderHeader" width="100">
                <template v-slot="{row:{sales_volume}}">
                  <div>{{ sales_volume|numberFormat }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="settlement_amount" label="结算金额" :render-header="renderHeader"
                               width="100">
                <template v-slot="{row:{settlement_amount}}">
                  <div>{{ settlement_amount|numberFormat(2) }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="commission_income" label="佣金收入" width="100">
                <template v-slot="{row:{commission_income}}">
                  <div>{{ commission_income|numberFormat(2) }}</div>
                </template>
              </el-table-column>
              <el-table-column label="佣金比例" width="100">
                <template v-slot="{row:{commission_rate}}">
                  <div>{{ commission_rate|numberFormat(2) }}</div>
                </template>
              </el-table-column>
              <el-table-column label="全案保量订单号">
                <template v-slot="{row:{order_no}}">
                  <div>{{ order_no }}</div>
                </template>
                <!--                <template v-slot="{$index:i}">-->
                <!--&lt;!&ndash;                  <el-input v-model="table[i].rebate_order_no" placeholder="全案保量订单号"/>&ndash;&gt;-->
                <!--                </template>-->
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="footer">
          <button-submit button-txt="确认认领" type="primary" @click.native.prevent="handleSure"/>
        </div>
      </el-form>
    </el-drawer>
  </div>
</template>
<script>

import {liveGuaranteeByRebate, liveGuaranteeQueryWmc} from "../../../../api/liveGuarantee";


export default {
  name: 'LiveGuaranteeStoreClaim',
  props: {
    getSelection: {
      type: Function,
      required: true
    },
    orderNo: {
      type: String
    }
  },
  data() {
    return {
      show: false,
      load: false,
      order: {},
      table: [],
      artist_name: '',
      form: {
        order_no: null,
        artist_id: null
      },
      rules: {
        order_no: [
          {
            trigger: "blur",
            validator: async (rule, order_no, cb) => {
              if (!order_no) {
                cb('请填写全案营销订单编号');
              }
              this.load = true
              const {success, model, message} = await liveGuaranteeQueryWmc({artist_id: this.form.artist_id, order_no});
              this.load = false
              if (!success) {
                cb(message || '系统服务异常'); //校验不通过，报错
              } else {
                this.order = model
                cb(); //校验通过
              }
            },
          }
        ]
      },
    }
  },
  created() {
    this.form.order_no = this.orderNo || null
  },
  methods: {
    handleSure: function () {
      const _this = this
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const {success} = await liveGuaranteeByRebate({records: _this.table})
          if (success) {
            this.show = false
            this.$message.success('认领成功，待财务确认！')
            this.$emit('success')
          }
        } else {
          return false;
        }
      });
    },
    assembleTable: function (table) {
      //全案保量订单号
      if (Array.isArray(table)) {
        table.map(_ => {
          _.rebate_order_no = null // 认领备注
        })
      } else {
        table = []
      }
      return table
    },
    renderHeader(h, {column}) {
      return h('div', {}, [
        h('div', {}, column.label.split('/')[0]),
        h('div', {}, column.label.split('/')[1])
      ])
    },
    handleShow: function () {
      const selection = this.getSelection()
      if (!selection.length) {
        this.$message.warning('请先选择要认领的行数据')
        return
      }
      let artist_id = 0
      selection.map(_ => {
        if (artist_id === 0) {
          artist_id = _.artist_id
        }
      })
      this.form.artist_id = artist_id
      this.artist_name = selection[0].artist_name || ''
      this.table = this.assembleTable(selection)
      this.show = true
    }
  }
}
</script>

<style lang="scss">
.live-guarantee-store-claim-drawer {
  width: 90% !important;

  .el-drawer__title {
    border-top-left-radius: 10px !important;
  }

  .el-drawer__header {
    font-size: 16px !important;
    color: #333333 !important;
    font-weight: 700;
    text-align: center;
  }

  .el-drawer__body {
    border-bottom-left-radius: 10px !important;
    padding: 0 40px 0 20px;
  }

  .footer {
    position: absolute;
    width: 100%;
    bottom: 0;
    right: 0;
    height: 66px;
    opacity: 1;
    background: #fff;
    box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, .04), 0 2px 4px 0 rgba(0, 0, 0, .5);
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    z-index: 99;
  }

  .module {
    margin: 20px 0;
    border: 1px dashed #F2F2F2;
    border-radius: 8px;
    padding: 20px 20px 20px 30px;

    &__title {
      font-size: 16px;
      color: #3c3c3c;
      margin-bottom: 20px;
      font-weight: bold;
      position: relative;
    }

    &__title::before {
      content: "";
      display: block;
      width: 3px;
      height: 24px;
      background-color: #B82C22;
      position: absolute;
      left: -8px;
      top: 0;
      border-radius: 2px;
    }

    thead th.is-leaf .cell {
      height: unset !important;
      line-height: 1 !important;
      padding-bottom: 4px;
    }

    .el-table th div {
      line-height: 1 !important;
    }
  }

  .module-order {
    height: 106px;
  }

  .module-live {
    height: calc(100% - 150px - 80px);
  }
}
</style>
